const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRocketLaunch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 200 228",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M100,228C155.228,228 200,183.228 200,128C200,72.772 155.228,28 100,28C44.772,28 0,72.772 0,128C0,183.228 44.772,228 100,228Z",
    style: {
      fill: "rgb(0,44,49)",
      fillOpacity: 0,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.462,182.987C6.056,167.21 0,148.312 0,128C0,72.772 44.772,28 100,28C155.228,28 200,72.772 200,128C200,144.913 195.801,160.845 188.389,174.811C178.829,173.591 170.7,180.87 170.36,190.07C165.91,189.69 161.84,191.13 158.73,193.74C148.83,186.53 134.86,192.69 133.45,204.79C128.16,202.24 122,206.11 122,211.99C122,212.22 122.02,212.44 122.04,212.66C112.96,202.78 109.34,181.13 108,167.99L92,167.99C92.29,179.69 87.19,204.51 77.27,211.8C75.17,208.32 71.36,205.99 67,205.99C67,199.66 62.09,194.48 55.87,194.03C54.32,181.33 39.2,175.55 29.56,183.88C25.7,181.81 20.972,181.327 16.462,182.987Z",
    style: {
      fill: "rgb(0,44,49)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.462,182.987C34.352,210.097 65.09,228 100,228C138.31,228 171.599,206.451 188.389,174.811C178.829,173.591 170.7,180.87 170.36,190.07C165.91,189.69 161.84,191.13 158.73,193.74C148.83,186.53 134.86,192.69 133.45,204.79C128.16,202.24 122,206.11 122,211.99C122,212.22 122.02,212.44 122.04,212.66C112.96,202.78 109.34,181.13 108,167.99L92,167.99C92.29,179.69 87.19,204.51 77.27,211.8C75.17,208.32 71.36,205.99 67,205.99C67,199.66 62.09,194.48 55.87,194.03C54.32,181.33 39.2,175.55 29.56,183.88C25.7,181.81 20.972,181.327 16.462,182.987Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.389,174.811C178.831,173.594 170.7,180.871 170.36,190.07C165.91,189.69 161.84,191.13 158.73,193.74C148.83,186.53 134.86,192.69 133.45,204.79C128.16,202.24 122,206.11 122,211.99C122,212.22 122.02,212.44 122.04,212.66C112.962,202.783 109.342,181.141 108.001,168L113.99,168C113.99,176 117.07,188.49 121.99,193.99C122,182.09 137.51,177.52 144.02,187.42C144.41,179.47 152.35,173.97 160.01,176.7C160.24,164.443 173.643,156.964 184.181,163.265C185.314,158.148 190.982,155.541 195.46,157.83C193.614,163.745 191.247,169.425 188.389,174.811ZM2.352,149.659C12.061,146.971 20.59,153.011 22.55,161.34C31.21,147.93 52.13,154.15 51.98,170.14C61.72,168.92 69.99,176.52 69.99,186C74.41,186 77.99,189.58 77.99,193.99C82.91,188.49 85.99,175.67 85.99,168L92,168C92.287,179.704 87.187,204.512 77.27,211.8C75.17,208.32 71.36,205.99 67,205.99C67,199.66 62.09,194.48 55.87,194.03C54.32,181.33 39.2,175.55 29.56,183.88C25.7,181.81 20.99,181.32 16.48,182.98L16.462,182.987C9.866,172.987 5.018,161.733 2.352,149.659Z",
    style: {
      fill: "white",
      fillOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121,168L79,168L83,160L117,160L121,168Z",
    style: {
      fill: "rgb(0,122,255)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.12,104.93C43.67,123.12 38,150.32 49.32,175C53.09,163.75 59.9,153.83 68.76,146.27C64.16,133.8 60.75,119.79 60.12,104.93Z",
    style: {
      fill: "rgb(0,227,107)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.88,104.93C139.25,119.79 135.83,133.8 131.24,146.27C140.11,153.83 146.92,163.75 150.68,175C162,150.32 156.33,123.12 139.88,104.93Z",
    style: {
      fill: "rgb(0,227,107)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.52,160L125.48,160C133.35,143.29 140,122.51 140,100C140,44.77 100,0 100,0C100,0 60,44.77 60,100C60,122.51 66.65,143.29 74.52,160Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,33.5C107.16,33.5 114.04,32.32 120.48,30.16C110.32,11.56 100,0 100,0C100,0 89.68,11.56 79.52,30.16C85.96,32.31 92.84,33.5 100,33.5Z",
    style: {
      fill: "rgb(0,122,255)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104,109C104,111.21 100,175 100,175C100,175 96,111.21 96,109C96,106.79 97.79,105 100,105C102.21,105 104,106.79 104,109Z",
    style: {
      fill: "rgb(10,239,184)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,100C140,44.77 100,0 100,0L100,175C100,175 100.39,168.7 100.94,160L125.48,160C133.35,143.29 140,122.51 140,100Z",
    style: {
      fill: "rgb(102,146,151)",
      fillOpacity: 0.25,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,89C111.046,89 120,80.046 120,69C120,57.954 111.046,49 100,49C88.954,49 80,57.954 80,69C80,80.046 88.954,89 100,89Z",
    style: {
      fill: "rgb(10,239,184)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,85C108.837,85 116,77.837 116,69C116,60.163 108.837,53 100,53C91.163,53 84,60.163 84,69C84,77.837 91.163,85 100,85Z",
    style: {
      fill: "rgb(0,168,184)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87,72C87,63.16 94.16,56 103,56C106.65,56 110.01,57.24 112.7,59.3C109.78,55.48 105.18,53 100,53C91.16,53 84,60.16 84,69C84,74.18 86.48,78.78 90.3,81.7C88.24,79.01 87,75.65 87,72Z",
    style: {
      fill: "rgb(84,86,87)",
      fillOpacity: 0.15,
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketLaunch);
export default __webpack_public_path__ + "static/media/rocket-launch.a9976c475407f10441407592f2fcce56.svg";
export { ForwardRef as ReactComponent };